import { render, staticRenderFns } from "./MensajePerito.vue?vue&type=template&id=0e1d4cb4&scoped=true&"
import script from "./MensajePerito.vue?vue&type=script&lang=js&"
export * from "./MensajePerito.vue?vue&type=script&lang=js&"
import style0 from "./MensajePerito.vue?vue&type=style&index=0&id=0e1d4cb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1d4cb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
